import React from "react";
import { Eye } from "lucide-react";
import { formatPhone } from "../../utils/utils";

interface DotData {
  _id: string;
  acceptedTerms: boolean;
  billingAddress: string;
  businessNames: {
    preference1: string;
    preference2: string;
    preference3: string;
  };
  emergencyContacts: {
    first: string;
    second: string;
    firstContactName: string;
    secondContactName: string;
  };
  documents: {
    creditCardFront: string | null;
    creditCardBack: string | null;
    driverLicenseFront: string | null;
    driverLicenseBack: string | null;
  };
  signature: string | null;
  specialRequest: string;
  createdAt: string;
  updatedAt: string;


}

interface Props {
  data: DotData;
}

const BusinessInfo: React.FC<Props> = ({ data }) => {

  if (!data) return null;

  const ImagePreview = ({ url }: { url: string | null }) =>
    url ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
      >
        <img
          src={url}
          alt="preview"
          className="h-12 w-auto border rounded bg-white p-1 hover:opacity-80"
        />
      </a>
    ) : (
      <span className="text-gray-400">Not uploaded</span>
    );

  return (
    <div className="flex flex-col h-[calc(86.5vh-200px)] 2xl:h-[calc(88vh-200px)] 4xl:h-[calc(92vh-200px)]">
      
      <div className="p-3 m-3 rounded-[10px] flex-1 border border-[#EEEEEE] bg-white pb-6 overflow-y-auto custom-scroll">
       <div
  className={`grid gap-3 mb-8 sm:grid-cols-2 lg:grid-cols-3`}
>
          {/* <thead>
            <tr className="bg-greenBg text-white">
              <th className="p-2 text-left w-1/3">Business Preferences</th>
              <th className="p-2 text-left w-1/3">Emergency & Billing</th>
              <th className="p-2 text-left w-1/3">Payment & Identification</th>
            </tr>
          </thead> */}

         
              {/* ================= BUSINESS ================= */}
              <div className='border-r-[1px] pr-3 border-r-[#EEEEEE]'>

                <div className="flex items-center gap-2 pb-2 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[18px] h-[18px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                    <img src="/assets/img/list-info.png" alt="" className='personIcon' />
                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Business Preferences</h2>
                            </div> 
                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">Business Name (1st)</label>
                   <p className="text-[13.5px] font-normal text-gray-900">
                    {data.businessNames.preference1 || "N/A"}
                  </p>
                </div>

                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">Business Name (2nd)</label>
                   <p className="text-[13.5px] font-normal text-gray-900">
                    {data.businessNames.preference2 || "N/A"}
                  </p>
                </div>

                <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">Business Name (3rd)</label>
                   <p className="text-[13.5px] font-normal text-gray-900">
                    {data.businessNames.preference3 || "N/A"}
                  </p>
                </div>

               <div className="mb-4 h-[40px]">
                                <label className="text-[11px] text-gray-500 block mb-1">Special Request</label>
                   <p className="text-[13.5px] font-normal text-gray-900">{data.specialRequest || "-"}</p>
                </div>
              </div>

              {/* ================= EMERGENCY ================= */}
          
          <div className='border-r-[1px] pr-3 border-r-[#EEEEEE]'>
                            <div className="flex items-center gap-2 pb-2 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[18px] h-[18px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                    <img src="/assets/img/contact.png" alt="" className='personIcon' />
                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Emergency & Billing</h2>
                            </div>
              <div className="mb-4 h-[40px]">
                  <label className="text-[11px] text-gray-500 block mb-1">Billing Address</label>
                   <p className="text-[13.5px] font-normal text-gray-900">{data.billingAddress}</p>
                </div>
                
                <div className="mb-4 h-[40px]">
                  <p className="text-[11px] text-gray-500 block mb-1"> Emergency Contact (Primary)</p>
                  <p className="text-[13.5px] font-normal text-gray-900">
                    {data.emergencyContacts.first ? formatPhone(data.emergencyContacts.first) : "N/A"}
                  </p>
                </div>
              
                {/* <div className="mb-4 h-[40px] pt-2">
                  <p className="text-[11px] text-gray-500 block mb-1">2nd Emergency Contact Name</p>
                  <p className="text-[13.5px] font-normal text-gray-900">
                    {data.emergencyContacts.secondContactName || "N/A"}
                  </p>
                </div> */}
               <div className="mb-4 h-[40px]">
                  <p className="text-[11px] text-gray-500 block mb-1">Emergency Contact (Secondary)</p>
                  <p className="text-[13.5px] font-normal text-gray-900">
                    {data.emergencyContacts.second ? formatPhone(data.emergencyContacts.second) : "N/A"}
                  </p>
                </div>

                <div className="mb-4 h-[40px]">
                  <p className="text-[11px] text-gray-500 block mb-1">SSN</p>
                  <div className="flex items-center justify-between"> <p className="text-[13.5px] font-normal text-gray-900">
                   ***-**-7158
                  </p>
                  <Eye size={18} className="text-gray-900 hover:text-greenBg cursor-pointer"/>
                  </div>
                 
                </div>

              </div>

              {/* ================= DOCUMENTS ================= */}
              <div className={` pr-3 `} >
                {/* Credit Card Details (Text instead of Images) */}

     

                                    <div className="flex items-center gap-2 pb-2 mb-2 border-b-[1px] border-b-[#EEEEEE]">
                                <div className="w-[18px] h-[18px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                   <img src="/assets/img/card.png" alt="" className='personIcon' />
                                </div>
                                <h2 className="text-[14px] font-medium text-gray-900">Payment and Identification</h2>
                            </div>

                <div className="mb-4 h-[40px]">
                  <p className="text-[11px] text-gray-500 block mb-1">Credit Card Name</p>
                  <p className="text-[13.5px] font-normal text-gray-900">
                     N/A
                  </p>
                </div> 



                 <div className="mb-4 h-[40px]">
                  <p className="text-[11px] text-gray-500 block mb-1">Credit Card Number</p>
                  <div className="flex items-center justify-between">
                  <p className="text-[13.5px] font-normal text-gray-900">**** **** **** 4545
                     </p>
                      <Eye size={18} className="text-gray-900 hover:text-greenBg cursor-pointer"/>
                  </div>
                </div> 
<div className="flex items-center justify-between w-full mb-4">
                <div>
                  <p className="text-[11px] text-gray-500 block mb-1">Expiry Date</p>
                  <p className="text-[13.5px] font-normal text-gray-900">
                    02/2027
                  </p>
                </div> 


                <div className="text-left">
    <p className="text-[11px] text-gray-500 mb-1">CVV</p>
      <div className="flex items-center gap-7">
    <p className="text-[13.5px] font-normal text-gray-900">
      ***
    </p>
    <Eye size={18} className="text-gray-900 hover:text-greenBg cursor-pointer"/>
    </div>
  </div>
</div>
                <div className="mb-4 h-[40px]">
                                <label className="text-[11px] text-gray-500 block ">Accepted Terms</label>
                  <span
                    className={`text-[13.5px] font-normal ${data.acceptedTerms
                      ? "text-green-600"
                      : "text-red-600"
                      }`}
                  >
                    {data.acceptedTerms ? "Yes" : "No"}
                  </span>
                </div>


              
           
       
        </div>
      

      
    
    </div>


<div >
                        <div className="flex items-center border-y border-gray-200  gap-2 py-2 mb-2">
                            <div className="w-[24px] h-[24px] bg-greenBtext-greenBg rounded-sm flex items-center justify-center flex-shrink-0">
                                <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#007070"
    width="24"
    height="24"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H5C4.44772 6 4 5.55228 4 5ZM7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12ZM7.25 15.5C7.25 15.0858 7.58579 14.75 8 14.75H13.5C13.9142 14.75 14.25 15.0858 14.25 15.5C14.25 15.9142 13.9142 16.25 13.5 16.25H8C7.58579 16.25 7.25 15.9142 7.25 15.5Z"
      fill="#007070"
    />
    <path
      d="M4.40879 4.0871C4.75727 4.24338 5 4.59334 5 5H17C17.3453 5 17.6804 5.04375 18 5.12602V4.30604C18 3.08894 16.922 2.15402 15.7172 2.32614L4.91959 3.86865C4.72712 3.89615 4.55271 3.97374 4.40879 4.0871Z"
      fill="#007070"
    />
  </svg>
                            </div>
                            <h2 className="text-[14px] font-semibold text-gray-900">Documents</h2>
                        </div>
        <div className=" mt-2  min-h-[9rem] py-1  shadow-sm">

          <div className=" grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* vertical line */}
            <div>
              <p className="text-[14px] font-normal text-gray-900 mb-1">Driver License (Front)</p>
              <ImagePreview url={data.documents?.driverLicenseFront} />
            </div>

            <div>
              <p className="text-[14px] font-normal text-gray-900">Driver License (Back)</p>
              <ImagePreview url={data.documents?.driverLicenseBack} />
            </div>

            <div>
              <p className="text-[14px] font-normal text-gray-900 mb-1">Signature</p>
              <ImagePreview url={data?.signature} />
            </div>


          </div>
        </div>
      </div>

     </div>
    </div>
  )
};

export default BusinessInfo;
